<div class="card shadow-sm border-0">
  <div class="card-body p-4">
    @if (showHeading) {
      <div class="d-flex align-items-start justify-content-between mb-1">
        <h5 class="font-size-16 mb-0">Finish setting up WhatsApp</h5>
        <span class="badge bg-soft-primary text-primary">
          {{ progress.completed }} of {{ progress.total }}
        </span>
      </div>
      <p class="text-muted font-size-13 mb-3">
        @if (progress.complete) {
          Everything we can see is done.
        } @else if (nextTask) {
          Next: {{ nextTask.label.toLowerCase() }}.
        } @else {
          A couple of things are still outstanding.
        }
      </p>
    }

    <div class="progress mb-4" style="height: 6px;">
      <div class="progress-bar bg-success"
           role="progressbar"
           [style.width.%]="progress.total ? (progress.completed / progress.total) * 100 : 0"
           [attr.aria-valuenow]="progress.completed"
           aria-valuemin="0"
           [attr.aria-valuemax]="progress.total"></div>
    </div>

    <ul class="list-unstyled mb-0">
      @for (task of progress.tasks; track task.id) {
        <li class="d-flex align-items-start mb-3">
          <i class="bx {{ iconFor(task) }} font-size-20 me-3 mt-1"></i>
          <div class="flex-grow-1">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <span class="fw-semibold font-size-14"
                    [class.text-muted]="task.state === 'done' || task.state === 'blocked'">
                {{ task.label }}
              </span>
              @if (task.state === 'unknown') {
                <span class="badge bg-soft-warning text-warning">Check this</span>
              }
              @if (task.state === 'blocked') {
                <span class="badge bg-soft-secondary text-muted">Do the step above first</span>
              }
            </div>

            <p class="text-muted font-size-13 mb-1">{{ task.detail }}</p>

            @if (task.state !== 'done' && task.state !== 'blocked') {
              @if (task.external) {
                <button type="button" class="btn btn-sm btn-outline-primary"
                        (click)="openMetaBilling()">
                  <i class="bx bx-link-external me-1"></i> Open Meta Business Manager
                </button>
              } @else if (task.route) {
                <a class="btn btn-sm btn-outline-primary" [routerLink]="task.route">
                  Go there
                </a>
              }
            }
          </div>
        </li>
      }
    </ul>

    <!-- Said plainly, because the checklist reaching the end does NOT mean
         Meta will accept a message: the payment method is the one thing Echo
         cannot read back, and it is also the most common reason a first send
         fails. -->
    @if (progress.complete) {
      <div class="alert alert-info border-0 font-size-13 mb-0 mt-3" role="alert">
        If your first message still will not send, it is almost always the payment
        method on Meta's side. We cannot see whether one has been added.
      </div>
    }
  </div>
</div>
